<footer class="bg-[#121826] text-white">
  <!-- Top Footer -->
  <allas-top-footer />
  <!-- Mobile Footer -->
  <allas-mobile-footer
    [currentYear]="currentYear"
    [expandedSections]="expandedSections"
    [customerService]="customerService"
    [company]="company"
    [services]="services"
    [cities]="cities"
    [shopping]="shopping"
    [categories]="categories"
    (toggleSection)="toggleSection($event)"
  ></allas-mobile-footer>

  <!-- Desktop Footer -->
  <allas-desktop-footer
    [customerService]="customerService"
    [company]="company"
    [services]="services"
    [cities]="cities"
    [shopping]="shopping"
    [categories]="categories"
  ></allas-desktop-footer>

  <!-- Bottom Footer -->
  <allas-bottom-footer
    [currentYear]="currentYear"
    [legal]="legal"
  ></allas-bottom-footer>
</footer>
